// extracted by mini-css-extract-plugin
module.exports = {"performanceWrapper":"MatchLiveAndFinished_performanceWrapper_LaRLx","navigationWrapper":"MatchLiveAndFinished_navigationWrapper_Ovs5j"};